import React from 'react';
import t from 'tcomb-form';

import baseFormFactory from './BaseForm';

import {ValidatonError} from '../resources/GenericResource';
import Calendar from '../components/Form_widgets/Calendar/Calendar';

const EditScheduleFormModel = t.struct({
    dates: t.Str
});

function calendarLayout(locals) {
    return (
        <Calendar disableBefore={this.props.disableBefore} selected={(locals.value === null ? [] : locals.value.split('|'))}
                  onChange={locals.onChange} />
    );
}

class FormLayout extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selected: []
        };
    }

    render() {
        const {inputs, value} = this.props;

        return (
            <div className="grid-row">
                <div className="grid-col center">
                    {inputs.dates}
                </div>
            </div>
        );
    }
}

function makeLayout(locals) {
    return <FormLayout {...locals}/>
}

const Form = baseFormFactory(EditScheduleFormModel, true, true);

class EditScheduleForm extends Form {
    constructor(props) {
        super(props);
        let isValid = true;
        let test = Object.values(props.initialFormData);
        for (var i = 0; i < test.length; i++){
            if (typeof test[i] === 'undefined' || test[i] === ''){
                isValid = false;
                break;
            }
        }

        const value = props.initialFormData;

        this.state = {
            value,
            isValid
        };
    }

    onChange(value, path) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
        super.onChange(value);
    }

    getOptions() {
        const errors = this.props.errors;
        return {
            auto: 'none',

            template: makeLayout,

            fields: {
                dates: {
                    disableOrder: true,
                    disableAdd: true,
                    disableRemove: true,
                    template: calendarLayout.bind(this),
                    hasError: !!errors,
                    error: errors && Object.keys(errors).filter(x => x.indexOf('dates') > -1).length ? "TODO" : errors && errors.errors && Object.keys(errors.errors).filter(x => x.indexOf('dates') > -1).length ? "TODO": null
                }
            }
        };
    }

    render() {
        return (
            <div>
                <t.form.Form ref="form" value={this.state.value} type={this.getModel()}
                             options={this.buildOptions()} onChange={this.onChange.bind(this)}/>
            </div>
        );
    }
}

EditScheduleForm.propTypes = {
    initialFormData: React.PropTypes.object.isRequired
};


export default EditScheduleForm;



/** WEBPACK FOOTER **
 ** ./app/src/forms/EditScheduleForm.js
 **/